export enum UnidadeAjustePrecoEnum {
  ValorFixo = 1,
  Percentual = 2,
}
